export class RadReportsPage extends HTMLElement {
    constructor()
    {
        super();
    }
 
    connectedCallback()
    {
        this.init();
    }
 
    init()
    {
        this.initEventHandlers();
    }

    initEventHandlers()
    {
        this._boundOnPopState = this.onPopState.bind(this);
        window.addEventListener('popstate', this._boundOnPopState);
    }

    disconnectedCallback()
    {
        window.removeEventListener('popstate', this._boundOnPopState);
    }
    onPopState(event)
    {
        event.stopImmediatePropagation();
        const backBtn = this.querySelector('.closeLevel');
        if (backBtn) {
            backBtn.click();
        }
    }
}
                
customElements.define('rad-reports-page', RadReportsPage);